export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://nearestdoctor-node.herokuapp.com';
export const BLOCKCHAIN_API_URL = process.env.REACT_APP_BLOCKCHAIN_NODE || 'https://nearestdoctor-blockchain-node1.herokuapp.com';

export default API_BASE_URL;
